<template>
  <font-awesome-icon
    icon="address-card"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons'

library.add(faAddressCard)

export default {
  name: 'CoozzyAddressCardIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
